module.exports = "/_next/static/images/2e6d0eed59955993d52426ebb63dc9f3-mulher-perfil-segurando-cartao-lg@2x.jpg";